{
  "add_all": {
    "title": "Voeg de publieke sleutels van onderstaande GSB's toe",
    "description": "De publieke sleutels staan op het overdrachtsplatform van de Kiesraad. Met de publieke sleutel kan Abacus controleren dat telbestanden echt van de betreffende GSB's komen en niet zijn gewijzigd."
  },
  "delete_are_you_sure": "Weet je zeker dat je deze sleutel wilt verwijderen? Deze actie kan niet worden teruggedraaid.",
  "delete_key": "Verwijder sleutel",
  "delete_public_key": "Publieke sleutel verwijderen?",
  "imported": "Geïmporteerde publieke sleutels",
  "invalid_public_key": "Ongeldige publieke sleutel",
  "keys": "Sleutels",
  "key_added": "Publieke sleutel {authority_name} toegevoegd",
  "key_already_added": "Publieke sleutel al geïmporteerd",
  "key_deleted": "Publieke sleutel {authority_name} verwijderd",
  "key_expired": "<strong>Let op:</strong> Deze sleutel is verlopen op {date}, maar kan wel gebruikt worden. Neem bij twijfel contact op met het GSB van {authority_name} of de Kiesraad.",
  "key_unknown_subcommittee": "Publieke sleutel van onbekend stembureau",
  "key_wrong_election": "Publieke sleutel voor andere verkiezing",
  "manage": "Sleutels van GSB's beheren",
  "non_last_key_deleted": "De sleutel is verwijderd. Onderstaande sleutels zijn nog aanwezig.",
  "no_public_key": "Geen publieke sleutel",
  "pending": "Nog toe te voegen publieke sleutels",
  "public_keys_explanation": "Met deze publieke sleutel(s) kan iedereen controleren dat bestanden die zijn ondertekend door het GSB {authority_name} echt van dit GSB komen en niet zijn gewijzigd.",
  "public_keys_for": "Publieke sleutel(s) GSB {authority_name}",
  "title": "Sleutelbeheer"
}
